export const DEFAULT_COLUMN_WIDTH = 'minmax(120px, 1fr)'

const COLUMN_MIN_PX = /^(?:minmax\()?(\d+)px/

export const getColumnsMinWidthPx = (widths: (string | undefined)[]) =>
  widths.reduce((sum, width) => {
    const match = COLUMN_MIN_PX.exec(width ?? DEFAULT_COLUMN_WIDTH)
    return sum + (match ? Number(match[1]) : 0)
  }, 0)
